module.exports = __webpack_public_path__ + "img/competicion-litigacion-internacional-mout-court-universidad-de-alcala.2b3f2c1e.jpg";